import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import api from "../../../../api/api";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Space,
  Switch,
} from "antd";
import { IconLeft, IconRight, IconUploadImage, IconEditPen } from "@assets";
import { useNavigate } from "react-router-dom";
import {
  CheckOutlined,
  CloseCircleFilled,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { OptionCard, OptionItem, OptionsWrapper } from "../Products";
import { useDispatch, useSelector } from "react-redux";
import {
  setHasVariant,
  setSelectedVariants,
  setVariantToEdit,
  updateFormValues,
} from "@store/product/productSlice";
import { updateProductState, initialState } from "@store/product/productSlice";
import { v4 as uuid } from "uuid";
import { IconLink } from "../../../../assets/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { localStorage } from "@utils";
import { useTranslation } from "react-i18next";

export const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote","link"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["clean"],
  ],
};

export const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link"
];

const RootContainer = styled.div`
  > .ant-row {
    margin-top: 24px;
  }

  .ant-form {
    width: 100%;
  }

  .ant-form-item:last-child {
    text-align: right;

    .ant-btn-primary {
      width: 172px;
      height: 48px;
    }
  }
`;

const Topbar = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: center;

  .ant-btn-default {
    height: 48px;
    padding: 0 12px !important;
    border: none !important;
    background: ${(props) => props.theme.backgroundColor} !important;
    color: ${(props) => props.theme.primaryColor} !important;
  }

  .ant-btn-primary {
    width: 172px;
    height: 48px;
  }
`;

const TitleWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #1d1014;
  line-height: 1;
`;

const GrayTitle = styled(Title)`
  color: #868686;
`;

const StepTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
`;

const StepTitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
`;

const Line = styled.div`
  flex: 1;
  width: 100%;
  height: 1px;
  background-color: #e9e9e9;
`;

const LeftSide = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  background-color: ${(props) => props.theme.backgroundColor};

  label {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Text = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  color: #1d1014;
  text-align: left;
`;

const LightText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #686868;
  text-align: center;
`;

const GrayText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #b9b9b9;
  white-space: pre-wrap;
  text-align: center;
`;

const Box = styled.div`
  width: 70%;
  height: auto;
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #b9b9b9;
  cursor: pointer;
  position: relative;

  .anticon {
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 32px;
    color: #868686;
  }
`;

const SmallBox = styled(Box)`
  width: 64px;
  margin-top: -24px;

  .ant-image img {
    height: 64px;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 8px;
  }
  .anticon {
    font-size: 20px;
  }
`;

const StepContainer = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 8px;

  .hidden-input {
    display: none !important;
  }

  .ant-form-item {
    margin-bottom: 0 !important;
  }

  .table-form {
    padding: 24px 0;
    border-bottom: 1px solid #fff;

    :last-child {
      border: none;
    }
  }

  .ant-col-custom {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;


const StepTopbar = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  ${Text} {
    flex: 1;
  }

  svg {
    cursor: pointer;
  }
    @media (max-width: 480px){
    gap:10px;
    }
`;

const LinkText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => (props.$active ? "#005AFF" : "#1d1014")};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
`;


const Wrapper = styled.div`
display:flex;
justify-content:space-between;
align-items:center;

@media (max-width: 480px){
flex-direction:column;
justify-content:start;
align-items:flex-start;
gap:10px;
margin-bottom:20px;
}
`

const groupBy = (data) => {
  const grouped = Object.entries(
    data.reduce((acc, pair) => {
      const key = pair[0].name; // group by first item's name
      if (!acc[key]) acc[key] = [];
      acc[key].push({ id: uuid(), values: pair });
      return acc;
    }, {})
  ).map(([name, items]) => ({
    name,
    items,
  }));
  return grouped;
};

const OptionsCard = ({
  is_active,
  options,
  allOptions,
  goToAddOptions,
  handleStatusChange,
  handleEditClicked,
}) => {

  const {t} = useTranslation();

  return (
    <OptionCard>
      {is_active ? (
        <>
          <OptionsWrapper>
            <Text>{t("product_option")} ({options.length})</Text>
            <LightText>
             {t('general_options_text')}
            </LightText>
            <Space wrap>
              {options.map((opt, key) => (
                <OptionItem key={key}>
                  <div
                    style={{
                      maxWidth: "400px",
                      overflow: "clip",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <Text
                      style={{
                        display: "flex",
                        overflow: "clip",
                        maxWidth: "400px",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {opt.option_name.name}
                      <LightText>{`(${opt.option_values.map(
                        (v) => v.name
                      )})`}</LightText>
                    </Text>
                  </div>
                  <IconEditPen onClick={() => handleEditClicked(opt)} />
                </OptionItem>
              ))}
            </Space>
          </OptionsWrapper>
          {(options.length === 0 || allOptions.length > options.length) && (
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={goToAddOptions}
            >
              {t('add_option')}
            </Button>
          )}
        </>
      ) : (
        <OptionsWrapper>
          <Text>{t('product_options_eg')}</Text>
        </OptionsWrapper>
      )}
      <Switch value={is_active} onChange={handleStatusChange} />
    </OptionCard>
  );
};

const Item = ({ combination }) => {
  const [file, setFile] = useState(null);

  const {t} = useTranslation();

  const handleFileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    setFile(e.target.files[0]);
  };

  const handleRemoveClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFile(null);
  };

  return (
    <Row gutter={[16, 8]} className="table-form">
      <Col xs={3} />
      <Col xs={21}>
        <Row gutter={[16, 8]}>
          <Col xs={6}>{t('product_option')}</Col>
          <Col xs={6}>{t('stock')}</Col>
          <Col xs={6}>{t('buy_price')}</Col>
          <Col xs={6}>{t('sell_price')}</Col>
        </Row>
      </Col>
      <Col xs={3}>
        <label htmlFor={`file-input-${combination.name}`}>
          <SmallBox>
            {file ? (
              <Image src={URL.createObjectURL(file)} preview={false} />
            ) : (
              <IconUploadImage />
            )}
            {file && <CloseCircleFilled onClick={handleRemoveClicked} />}
          </SmallBox>
        </label>
        <input
          id={`file-input-${combination.name}`}
          type="file"
          disabled={file}
          hidden
          onChange={handleFileChange}
          className="hidden-input"
          accept=".jpg,.jpeg,.png"
        />
      </Col>
      <Col xs={21}>
        <Row gutter={[16, 8]}>
          {combination.items.map((item) => {
            let names = item.values.map((x) => x.name);
            return (
              <>
                <Col xs={6} className="ant-col-custom">
                  {names.join(", ")}
                </Col>
                <Col xs={6}>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                    name={`stock_${item.id}`}
                  >
                    <Input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      min={0}
                    />
                  </Form.Item>
                </Col>
                <Col xs={6}>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                    name={`buy_price_${item.id}`}
                  >
                    <Input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      // min={-0}
                    />
                  </Form.Item>
                </Col>
                <Col xs={6}>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: "",
                      },
                    ]}
                    name={`sell_price_${item.id}`}
                  >
                    <Input
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      // min={-0}
                    />
                  </Form.Item>
                </Col>
              </>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
};

const CHAR_LIMIT = 1000;

// helper to strip HTML and get plain text
const stripHtml = (html = "") => {
  if (typeof document === "undefined") {
    // server-side fallback (very simple)
    return html.replace(/<[^>]+>/g, "");
  }
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const CreateProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    has_variant,
    selected_variants,
    category_id,
    file,
    form_values,
    thumb_image,
    imageFiles,
    images,
    step,
    combinations,
    isReEdited,
  } = useSelector((state) => state.product);
  const [all_variants, setAllVariants] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sub_categories, setSubCategories] = useState([]);
  const [catalogues, setCatalogues] = useState([]);
  const [brands, setBrands] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [variantConfirmLoading, setVariantConfirmLoading] = useState(false);
  const [form] = Form.useForm();
  const [localImages, setLocalImages] = useState([]);
  const [stockLinked, setStockLinked] = useState(false);
  const [priceLinked, setPriceLinked] = useState(false);

    const storeLang = localStorage.getStoreLang() || [];
    const langCount = storeLang?.length;

    const {t} = useTranslation();


       // quill refs for programmatic control (truncate with setText)
      const primaryQuillRef = useRef(null);
      const secondaryQuillRef = useRef(null);
    
      // counters
      const [primaryCount, setPrimaryCount] = useState(0);
      const [secondaryCount, setSecondaryCount] = useState(0);

  useEffect(() => {
    getCategories();
    getBrands();
    getProductOptions();

    // TO FIX

    // return () => {
    //     dispatch(updateProductState(initialState));
    // }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (category_id) {
      getSubCategories(category_id);
      getCatalogues(category_id);
    }

    // eslint-disable-next-line
  }, [category_id]);

  useEffect(() => {
    form.setFieldsValue(form_values);
  }, [form, form_values]);

  useEffect(() => {
    if (thumb_image && images.length === imageFiles.length && !isReEdited) {
      if (has_variant) {
        setConfirmLoading(false);
        dispatch(updateProductState({ step: 2 }));
        const _combinations = groupBy(generateCombinations(selected_variants));
        dispatch(updateProductState({ combinations: _combinations }));
      } else {
        doPost();
      }
    }

    // eslint-disable-next-line
  }, [thumb_image, images]);

  const getProductOptions = () => {
    api
      .getProductOptions()
      .then(({ data }) => {
        setAllVariants(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };
  

  const getCategories = () => {
    api
      .getCategories({ status: true, has_sub: true })
      .then(({ data }) => {
        setCategories(
          data.map((x) => {
            return {
              value: x.id,
              label: `${x.name?.primary} ${langCount === 2 ? '('+x.name?.secondary+')' : ""}`,
            };
          })
        );
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const getSubCategories = (category_id) => {
    api
      .getSubCategories({ category_id, status: true })
      .then(({ data }) => {
        setSubCategories(
          data.map((x) => {
            return {
              value: x.id,
              label: `${x.name?.primary} ${langCount === 2 ? '('+x.name?.secondary+')' : ""}`,
            };
          })
        );
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const getCatalogues = (category_id) => {
    api
      .getCatalogues({ category_id, status: true })
      .then(({ data }) => {
        setCatalogues(
          data.map((x) => {
            return {
              value: x.id,
              label: `${x.name?.primary} ${langCount === 2 ? '('+x.name?.secondary+')' : ""}`,
            };
          })
        );
      })
      .catch((error) => {
        message.error(error);
      });
  };
  const getBrands = () => {
    api
      .getBrands({ is_active: true })
      .then(({ data }) => {
        setBrands(
          data.map((x) => {
            return {
              value: x.id,
              label: x.name,
            };
          })
        );
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const attribute_ids = selected_variants?.map((v, idx) => {
    return {
      attribute_id: v.option_name?.id,
      display_order: idx + 1,
    };
  });

  const doPost = async (product_variants) => {
    setConfirmLoading(true);
    setVariantConfirmLoading(true);

    try {
      // 1. Upload all local images
      const uploadedImageUrls = [];
      for (const file of localImages) {
        const { data } = await api.uploadMedia({ file, file_path: file.type });
        uploadedImageUrls.push(data.url);
      }

      // 2. Create payload
      let {
        name_primary,
        name_secondary,
        description_primary,
        description_secondary,
        category,
        sub_category,
        catalogue,
        stock_quantity,
        buy_price,
        sell_price,
        brand_id,
        search_keywords,
        stock_alert,
      } = form_values;

      let payload = {
        has_variant,
        thumb_image,
        images: uploadedImageUrls,
        product_name: {
          primary: name_primary,
          secondary: langCount === 2 ? name_secondary : null,
        },
        description: {
          primary: description_primary,
          secondary: langCount === 2 ? description_secondary : null,
        },
        search_keywords: search_keywords?.split(",")?.map((k) => k.trim()),
        category,
        sub_category,
        catalogue,
        buy_price: Number(buy_price || 0),
        sell_price: Number(sell_price),
        stock_quantity: parseInt(stock_quantity || 0),
        stock_alert: parseInt(stock_alert || 0),
      };

      if (brand_id) {
        payload.brand_id = brand_id;
      }

      if (has_variant && product_variants) {
        payload.product_variants = product_variants;
        payload.attribute_ids = attribute_ids;
      }

      // 3. Post product
      await api.createProduct(payload);

      message.success(t('product_create_success'));
      goBack();
    } catch (error) {
      message.error(error);
    } finally {
      setConfirmLoading(false);
      setVariantConfirmLoading(false);
    }
  };

  function generateCombinations(variants, depth = 0, path = [], results = []) {
    if (depth === variants.length) {
      results.push(
        path.map((v) => {
          return { name: v.name, id: v.id };
        })
      );
      return;
    }

    const current_variant = variants[depth];
    current_variant.option_values.forEach((value) => {
      generateCombinations(variants, depth + 1, [...path, value], results);
    });

    return results;
  }

  const onFinish = (values) => {
    if (!confirmLoading) {
      if (!file) {
        message.warning(t('plz_add_photo'));
        return;
      }
      dispatch(updateProductState({ isReEdited: false }));

      if (has_variant && selected_variants.length === 0) {
        message.warning(t('plz_add_option'));
        return;
      }
      setConfirmLoading(true);
      dispatch(updateProductState({ form_values: values }));
      uploadThumbImage(file);
      uploadImages(imageFiles);
    }
  };

  const uploadThumbImage = (file) => {
    api
      .uploadMedia({
        file,
        file_path: file.type,
      })
      .then(({ data: { url } }) => {
        dispatch(updateProductState({ thumb_image: url }));
      })
      .catch((error) => {
        setConfirmLoading(false);
        message.error(error);
      });
  };

  const uploadImages = (files) => {
    files.forEach((file) => {
      api
        .uploadMedia({
          file,
          file_path: file.type,
        })
        .then(({ data: { url } }) => {
          dispatch(updateProductState({ images: [...images, url] }));
        })
        .catch((error) => {
          setConfirmLoading(false);
          message.error(error);
        });
    });
  };

  const goToAddOptions = () => {
    const currentValues = form.getFieldsValue();
    dispatch(updateFormValues(currentValues));
    navigate(`add-options`);
  };

  const handleOptionStatusChange = () => {
    dispatch(setHasVariant(!has_variant));
    dispatch(setSelectedVariants([]));
    dispatch(updateProductState({ step: 1 }));
  };

const handleFileChange = (e) => {
  if (e.target.files.length === 0) return;

  dispatch(updateProductState({ file: e.target.files[0] }));
};

  const handleFormChange = (changedValues, allValues) => {
    dispatch(updateFormValues(allValues));
  };

  // const handleRemoveClicked = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
  //   dispatch(updateProductState({ file: null }));
  // };

  const handleRemoveClicked = (e) => {
  e.preventDefault();
  e.stopPropagation();

  const fileInput = document.getElementById("file-input");
  if (fileInput) {
    fileInput.value = ""; // reset input value
  }

  dispatch(updateProductState({ file: null }));
};

  const handleEditOptionClicked = (option) => {
    dispatch(setVariantToEdit(option));
    goToAddOptions();
  };

  // Manage Variants

  const formatProductVariants = (combination_values, fileMap = {}) => {
    let product_variants = [];
    combinations.forEach((group) => {
      const groupName = group.name;
      const image_url = fileMap[groupName] || "";

      group.items.forEach((item) => {
        const id = item.id;
        const variant_values = item.values.map((v) => v.id);

        product_variants.push({
          image_url,
          variant_values,
          buy_price: Number(combination_values[`buy_price_${id}`] ?? 0),
          sell_price: Number(combination_values[`sell_price_${id}`] ?? 0),
          stock_quantity: parseInt(combination_values[`stock_${id}`] ?? 0),
        });
      });
    });
    return product_variants;
  };

  const onVariantsFinish = (combination_values) => {
    if (!variantConfirmLoading) {
      setVariantConfirmLoading(true);

      let _uploaded_files = [];

      const uploadPromises = combinations.map((combination) => {
        const file = document.getElementById(`file-input-${combination.name}`)
          .files[0];
        if (!file) {
          _uploaded_files = [];
          return Promise.reject(`Missing file for ${combination.name}`);
        }

        return api
          .uploadMedia({
            file,
            file_path: file.type,
          })
          .then(({ data: { url } }) => {
            _uploaded_files.push({ file: url, id: combination.name });
          })
          .catch((error) => {
            _uploaded_files = [];
            return Promise.reject(error); // Important to reject so Promise.all fails if needed
          });
      });

      Promise.all(uploadPromises)
        .then(() => {
          // Create a quick lookup map for files
          const fileMap = Object.fromEntries(
            _uploaded_files.map((d) => [d.id, d.file])
          );
          let product_variants = formatProductVariants(
            combination_values,
            fileMap
          );
          createProductWithVariants(product_variants);
        })
        .catch((error) => {
          setVariantConfirmLoading(false);
          message.error(error);
        });
    }
  };

  const createProductWithVariants = (product_variants) => {
    doPost(product_variants);
  };

  const handleCategoryChange = (value) => {
    dispatch(updateProductState({ category_id: value }));
    form.setFieldValue("sub_category", null);
    form.setFieldValue("catalogue", null);
  };

  const goBack = () => {
    navigate(-1);
    dispatch(updateProductState(initialState));
  };

  const handleLinkAllStock = () => {
    const values = form.getFieldsValue();
    const keys = combinations.flatMap((combination) =>
      combination.items.map((item) => `stock_${item.id}`)
    );
    const [firstKey, ...restKeys] = keys;
    const firstValue = values[firstKey];
    if (firstValue === undefined) return;

    const update = {};
    if (!stockLinked) {
      restKeys.forEach((key) => {
        update[key] = firstValue;
      });
      setStockLinked(true);
    } else {
      restKeys.forEach((key) => {
        update[key] = undefined;
      });
      setStockLinked(false);
    }
    form.setFieldsValue(update);
  };

  const handleLinkAllPrice = () => {
    const values = form.getFieldsValue();
    const buyKeys = combinations.flatMap((combination) =>
      combination.items.map((item) => `buy_price_${item.id}`)
    );
    const sellKeys = combinations.flatMap((combination) =>
      combination.items.map((item) => `sell_price_${item.id}`)
    );

    const [firstBuyKey, ...restBuyKeys] = buyKeys;
    const [firstSellKey, ...restSellKeys] = sellKeys;
    const firstBuy = values[firstBuyKey];
    const firstSell = values[firstSellKey];

    if (firstBuy === undefined || firstSell === undefined) return;

    const update = {};
    if (!priceLinked) {
      restBuyKeys.forEach((key) => {
        update[key] = firstBuy;
      });
      restSellKeys.forEach((key) => {
        update[key] = firstSell;
      });
      setPriceLinked(true);
    } else {
      restBuyKeys.forEach((key) => {
        update[key] = undefined;
      });
      restSellKeys.forEach((key) => {
        update[key] = undefined;
      });
      setPriceLinked(false);
    }

    form.setFieldsValue(update);
  };

  useEffect(() => {
  if (!form_values) return;

  // Restore AntD form fields
  form.setFieldsValue(form_values);

  // --- Restore Primary Editor ---
  if (primaryQuillRef.current) {
    const primaryEditor = primaryQuillRef.current.getEditor();
    if (primaryEditor && !primaryEditor.hasLoaded) {
  const active = document.activeElement; // save current focus

  const primaryHtml = form_values.description_primary || "";
  const primaryPlain = stripHtml(primaryHtml);

  // prevent Quill from focusing while setting content
  primaryEditor.enable(false);
  // primaryEditor.clipboard.dangerouslyPasteHTML(0, primaryHtml);
  primaryEditor.enable(true);

  setPrimaryCount(primaryPlain.length);
  primaryEditor.hasLoaded = true;

  // restore focus to the previously active element (if any)
  if (active && typeof active.focus === "function") {
    active.focus();
  }
}
  }

  // --- Restore Secondary Editor (if 2 languages) ---
  if (langCount === 2 && secondaryQuillRef.current) {
    const secondaryEditor = secondaryQuillRef.current.getEditor();
    if (secondaryEditor && !secondaryEditor.hasLoaded) {
  const active = document.activeElement;

  const secondaryHtml = form_values.description_secondary || "";
  const secondaryPlain = stripHtml(secondaryHtml);

  secondaryEditor.enable(false);
  // secondaryEditor.clipboard.dangerouslyPasteHTML(0, secondaryHtml);
  secondaryEditor.enable(true);

  setSecondaryCount(secondaryPlain.length);
  secondaryEditor.hasLoaded = true;

  if (active && typeof active.focus === "function") {
    active.focus();
  }
}

  }
}, [form_values]);

const handlePrimaryQuillChange = (content) => {
  const plain = stripHtml(content);
  const quill = primaryQuillRef.current?.getEditor();
  if (!quill) return;

  if (plain.length > CHAR_LIMIT) {
    const extra = plain.length - CHAR_LIMIT;

    // delete extra text (preserves all formatting)
    quill.deleteText(CHAR_LIMIT, extra, "user");

    // update form & counter after trimming
    const newHtml = quill.root.innerHTML;
    form.setFieldValue("description_primary", newHtml);
    setPrimaryCount(CHAR_LIMIT);

    message.warning(`${t('message_limit_reached', {count:CHAR_LIMIT})}`);
  } else {
    form.setFieldValue("description_primary", content);
    setPrimaryCount(plain.length);
  }
};

const handleSecondaryQuillChange = (content) => {
  const plain = stripHtml(content);
  const quill = secondaryQuillRef.current?.getEditor();
  if (!quill) return;

  if (plain.length > CHAR_LIMIT) {
    const extra = plain.length - CHAR_LIMIT;

    quill.deleteText(CHAR_LIMIT, extra, "user");

    const newHtml = quill.root.innerHTML;
    form.setFieldValue("description_secondary", newHtml);
    setSecondaryCount(CHAR_LIMIT);

    message.warning(`Character limit of ${CHAR_LIMIT} reached`);
  } else {
    form.setFieldValue("description_secondary", content);
    setSecondaryCount(plain.length);
  }
};



  return (
    <RootContainer>
      <Topbar>
        <Button type="default" icon={<IconLeft />} onClick={goBack}>
          {t('back')}
        </Button>
        <TitleWrapper>
          <GrayTitle>{t('products')}</GrayTitle>
          <IconRight />
          <Title>{t('create_product')}</Title>
        </TitleWrapper>
      </Topbar>
      <OptionsCard
        mode="create"
        is_active={has_variant}
        options={selected_variants}
        allOptions={all_variants}
        goToAddOptions={goToAddOptions}
        handleStatusChange={handleOptionStatusChange}
        handleEditClicked={handleEditOptionClicked}
      />
      {has_variant && (
        <StepTitleWrapper>
          <StepTitle>
            {step === 1
              ? t('step_1')
              : t('step_2')}
          </StepTitle>
          <Line />
        </StepTitleWrapper>
      )}

      {step === 1 ? (
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={6}>
            <LeftSide>
              <Text>{t('image')}</Text>
              <label htmlFor="file-input">
                <Box style={{ maxWidth: "200px" }}>
                  {file ? (
                    <Image src={URL.createObjectURL(file)} preview={false} />
                  ) : (
                    <>
                      <IconUploadImage />
                      <GrayText>{`Upload image or \n drop a file`}</GrayText>
                    </>
                  )}
                  {file && <CloseCircleFilled onClick={handleRemoveClicked} />}
                </Box>
              </label>
              <input
                id="file-input"
                type="file"
                disabled={file}
                accept=".jpg,.jpeg,.png"
                hidden
                onChange={handleFileChange}
              />
              {!has_variant && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {localImages.map((file, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <Image
                        src={URL.createObjectURL(file)}
                        width={56}
                        height={56}
                        preview={false}
                        style={{ borderRadius: 8, objectFit: "cover" }}
                      />
                      <CloseCircleFilled
                        onClick={() => {
                          const newFiles = [...localImages];
                          newFiles.splice(index, 1);
                          setLocalImages(newFiles);
                        }}
                        style={{
                          position: "absolute",
                          top: -6,
                          right: -6,
                          fontSize: 16,
                          color: "#868686",
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                      />
                    </div>
                  ))}
                  {localImages.length < 8 && (
                    <label
                      htmlFor="upload-more"
                      style={{
                        width: 56,
                        height: 56,
                        border: "1px dashed #b9b9b9",
                        borderRadius: 8,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <PlusCircleOutlined
                        style={{ fontSize: 20, color: "#ccc" }}
                      />
                      <input
                        id="upload-more"
                        type="file"
                        accept="image/*"
                        multiple
                        hidden
                        onChange={(e) => {
                          const files = Array.from(e.target.files); // Get all selected files
                          if (!files) return;
                          setLocalImages((prev) =>
                            [...prev, ...files].slice(0, 8)
                          ); // Limit to 8 files
                        }}
                      />
                    </label>
                  )}
                </div>
              )}
              <LightText>
                {t('image_limit')}
              </LightText>
            </LeftSide>
          </Col>
          <Col xs={24} lg={18}>
            <Form
              form={form}
              initialValues={{
                ...form_values,
              }}
              onFinish={onFinish}
              onValuesChange={handleFormChange}
              layout="vertical"
            >
              <Form.Item
                name={"name_primary"}
                rules={[
                  {
                    required: true,
                    message: ` ${t('enter_product_name')} (${storeLang[0]?.language})`,
                  },
                ]}
                label={`${t('product_name')} (${storeLang[0]?.language})`}
              >
                <Input
                  placeholder={`${t('product_name')} (${storeLang[0]?.language})`}
                  maxLength={300}
                  showCount
                />
              </Form.Item>
              {langCount === 2 &&
              <Form.Item
                name={"name_secondary"}
                rules={[
                  {
                    required: true,
                    message: ` ${t('enter_product_name')} (${storeLang[1]?.language})`,
                  },
                ]}
                label={`${t('product_name')} (${storeLang[1]?.language})`}
              >
                <Input
                  placeholder={`${t('product_name')} (${storeLang[1]?.language})`}
                  maxLength={300}
                  showCount
                />
              </Form.Item>
              }
              <Form.Item
                name={"category"}
                rules={[
                  {
                    required: true,
                    message: t('plz_select_category'),
                  },
                ]}
                label={t('category')}
              >
                <Select
                  placeholder={t('category')}
                  options={categories}
                  onChange={handleCategoryChange}
                  style={{ height: "fit-content" }}
                />
              </Form.Item>
              <Form.Item
                name={"sub_category"}
                rules={[
                  {
                    required: true,
                    message: " Please select a sub-category",
                  },
                ]}
                label={t('sub_category')}
              >
                <Select
                  placeholder={t('sub-category')}
                  options={sub_categories}
                  style={{ height: "fit-content" }}
                />
              </Form.Item>
              <Form.Item
                name={"catalogue"}
                rules={[
                  {
                    required: true,
                    message: t('plz_select_catalogue'),
                  },
                ]}
                label={t('catalogue')}
              >
                <Select
                  mode="multiple"
                  placeholder="Catalogue"
                  options={catalogues}
                  style={{ height: "fit-content" }}
                />
              </Form.Item>
              <Form.Item name={"brand_id"} label={"Brand"}>
                <Select
                  placeholder="Brand"
                  options={brands}
                  allowClear
                  style={{ height: "fit-content" }}
                />
              </Form.Item>
                {/* <Form.Item
                                  name={"description_primary"}
                                  rules={[
                                    {
                                      required: true,
                                      message: ` Please enter a description (${storeLang[0]?.language})`,
                                    },
                                  ]}
                                  label={`Description (${storeLang[0]?.language})`}
                                >
                                  <>
                                    <ReactQuill
                                      ref={primaryQuillRef}
                                      theme="snow"
                                      modules={modules}
                                      formats={formats}
                                      placeholder={`Please enter a description (${storeLang[0]?.language})`}
                                      onChange={handlePrimaryQuillChange}
                                    />
                                    <div style={{ textAlign: "right", marginTop: 6, fontSize: 12, color: primaryCount > CHAR_LIMIT ? "red" : "inherit" }}>
                                      {primaryCount}/{CHAR_LIMIT}
                                    </div>
                                  </>
                                </Form.Item>
                                {langCount === 2 &&
                                <Form.Item
                                  name={"description_secondary"}
                                  rules={[
                                    {
                                      required: true,
                                      message: ` Please enter a description (${storeLang[1]?.language})`,
                                    },
                                  ]}
                                  label={`Description (${storeLang[1]?.language})`}
                                >
                                  <>
                                    <ReactQuill
                                      ref={secondaryQuillRef}
                                      theme="snow"
                                      modules={modules}
                                      formats={formats}
                                      placeholder={`Please enter a description (${storeLang[1]?.language})`}
                                      onChange={handleSecondaryQuillChange}
                                    />
                                    <div style={{ textAlign: "right", marginTop: 6, fontSize: 12, color: secondaryCount > CHAR_LIMIT ? "red" : "inherit" }}>
                                      {secondaryCount}/{CHAR_LIMIT}
                                    </div>
                                  </>
                                </Form.Item>
                                } */}

                                  <Form.Item
                      name="description_primary"
                      rules={[
                        {
                          required: true,
                          message: ` ${t('plz_enter_desc')} (${storeLang[0]?.language})`,
                        },
                      ]}
                      label={`${t('description')} (${storeLang[0]?.language})`}
                    >
                      <>
                        <ReactQuill
                          ref={primaryQuillRef}
                          theme="snow"
                          modules={modules}
                          formats={formats}
                          placeholder={`${t('plz_enter_desc')} (${storeLang[0]?.language})`}
                          // ✅ Controlled by AntD form value
                          value={form.getFieldValue("description_primary") || ""}
                          onChange={(content) => handlePrimaryQuillChange(content)}
                        />
                        <div
                          style={{
                            textAlign: "right",
                            marginTop: 6,
                            fontSize: 12,
                            color: primaryCount > CHAR_LIMIT ? "red" : "inherit",
                          }}
                        >
                          {primaryCount}/{CHAR_LIMIT}
                        </div>
                      </>
                    </Form.Item>

                    {langCount === 2 && (
                      <Form.Item
                        name="description_secondary"
                        rules={[
                          {
                            required: true,
                            message: `${t('plz_enter_desc')} (${storeLang[1]?.language})`,
                          },
                        ]}
                        label={`${t('description')} (${storeLang[1]?.language})`}
                      >
                        <>
                          <ReactQuill
                            ref={secondaryQuillRef}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            placeholder={`${t('plz_enter_desc')} (${storeLang[1]?.language})`}
                            value={form.getFieldValue("description_secondary") || ""}
                            onChange={(content) => handleSecondaryQuillChange(content)}
                          />
                          <div
                            style={{
                              textAlign: "right",
                              marginTop: 6,
                              fontSize: 12,
                              color: secondaryCount > CHAR_LIMIT ? "red" : "inherit",
                            }}
                          >
                            {secondaryCount}/{CHAR_LIMIT}
                          </div>
                        </>
                      </Form.Item>
                    )}
              <Form.Item
                name={"search_keywords"}
                rules={[
                  {
                    required: true,
                    message: t('plz_enter_keyword'),
                  },
                ]}
                label={t('search_keyword')}
              >
                <Input placeholder={t('search_keyword')} />
              </Form.Item>
              {!has_variant && (
                <Form.Item
                  name={"buy_price"}
                  rules={[
                    {
                      required: !has_variant,
                      message: t('plz_enter_buy'),
                    },
                  ]}
                  label={t('buy_price')}
                >
                  <Input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    placeholder={t('buy_price')}
                   onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                  />
                </Form.Item>
              )}
              <Form.Item
                name={"sell_price"}
                rules={[
                  {
                    required: true,
                    message: t('enter_sell_price'),
                  },
                ]}
                label={has_variant ? t('sell_price_default') : t('sell_price')}
              >
                <Input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  placeholder={
                    has_variant ? t('sell_price_default') : t('sell_price')
                  }
                  onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                />
              </Form.Item>
              {!has_variant && (
                <Form.Item
                  name={"stock_quantity"}
                  rules={[
                    {
                      required: true,
                      message: t('enter_stock'),
                    },
                  ]}
                  label={t('stock_quantity')}
                >
                  <Input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    placeholder={t('stock_quantity')}
                    min={0}
                  />
                </Form.Item>
              )}
              <Form.Item
                name="stock_alert"
                rules={[
                  {
                    required: true,
                    message: t('stock_alert_quantity_text'),
                  },
                ]}
                label={t('stock_alert_quantity')}
              >
                <Input
                  placeholder={t('stock_alert_quantity')}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault(); // Block non-digit keypresses
                    }
                  }}
                  onPaste={(e) => {
                    const paste = e.clipboardData.getData("text");
                    if (!/^\d+$/.test(paste)) {
                      e.preventDefault(); // Block pasting non-numeric values
                    }
                  }}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={confirmLoading}
                  icon={<CheckOutlined />}
                >
                  {has_variant ? t('continue') : t('create')}
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      ) : (
        <StepContainer>
          <Wrapper>
          <StepTopbar>
            <Text>{t('price_stock')}</Text>
            <Space onClick={handleLinkAllStock}>
              <IconLink />
              <LinkText $active={stockLinked}>
                {stockLinked ? t('unlink_stock') : t('link_all_stock')}
              </LinkText>
            </Space>
            <Space onClick={handleLinkAllPrice}>
              <IconLink />
              <LinkText $active={priceLinked}>
                {priceLinked ? t('unlink_price') : t('link_all_price')}
              </LinkText>
            </Space>
          </StepTopbar>
          </Wrapper>
          <Form form={form} onFinish={onVariantsFinish}>
            {combinations.map((combination, key) => (
              <Item key={key} combination={combination} />
            ))}
            <Form.Item>
              <Space size={"middle"}>
                <Button 
                  style={{width:"100%"}}
                  type="primary"
                  onClick={() => {
                    setStockLinked(false);
                    setPriceLinked(false);
                    setVariantConfirmLoading(false);
                    dispatch(updateProductState({ step: 1, isReEdited: true }));
                  }}
                >
                  {t('re-edit_product')}
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={variantConfirmLoading}
                >
                  {t('create')}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </StepContainer>
      )}
    </RootContainer>
  );
};

export default CreateProduct;
